import { render, staticRenderFns } from "./ReporteFolioTransbordador.vue?vue&type=template&id=4ffd82ab&"
import script from "./ReporteFolioTransbordador.vue?vue&type=script&lang=js&"
export * from "./ReporteFolioTransbordador.vue?vue&type=script&lang=js&"
import style0 from "./ReporteFolioTransbordador.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports